import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { scaleOrdinal } from "d3-scale";
import { schemeCategory10 } from "d3-scale-chromatic";

type Data = {
  name: string;
  value: number;
};

type Props = {
  data: Data[];
};

// Create a color scale with d3-scale
const colorScale = scaleOrdinal(schemeCategory10);

const HomePieChart: React.FC<Props> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart width={400} height={400}>
        <Pie
          dataKey="value"
          isAnimationActive={false}
          data={data}
          cx="40%"
          cy="50%"
          outerRadius={100}
          label
          stroke="transparent"
        >
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colorScale(index.toString())}
              style={{ outline: "none" }}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    </ResponsiveContainer>
  );
};
export default HomePieChart;
